import { IThanhPhanMonActionTypes } from "../../action-types/category/IThanhPhanMonActions";
import { IThanhPhanMonReducer } from "../../reducer-model/category/IThanhPhanMonReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState  : IThanhPhanMonReducer = {
    status: eReducerStatusBase.is_not_initialization,
    thanhPhanMons: [],
};

export const thanhPhanMonReducer = (
    state: IThanhPhanMonReducer = iniState,
    action: IThanhPhanMonActionTypes
): IThanhPhanMonReducer => {
    switch (action.type) {
        case "THANH_PHAN_MON_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "THANH_PHAN_MON_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                thanhPhanMons: action.payload,
            };
        case "THANH_PHAN_MON_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "THANH_PHAN_MON_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                thanhPhanMonEditing: action.payload
            };
        case "THANH_PHAN_MON_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "THANH_PHAN_MON_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "THANH_PHAN_MON_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false
            };
        case "THANH_PHAN_MON_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "THANH_PHAN_MON_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "THANH_PHAN_MON_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "THANH_PHAN_MON_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}